export default __webpack_public_path__ + "static/media/tick-elite.69ba6ffa.svg";